export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 200 },
  { key: '2', headerName: 'Type Of Service', field: 'name', hide: false, width: 500 },
  { key: '3', headerName: 'Status', field: 'status', hide: false, width: 400 }
];